import React from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { StructureItem, BUDGET_STRUCTURE_STATUS } from 'domain/shared/newProject';

interface TotalFieldProps extends FieldProps {
  showContent: boolean;
  field: string;
  calculateResult: (budgetValues: any[], financeValues: any[], showContent: boolean) => string;
}

const TotalField = ({ source, field, showContent, calculateResult, ...props }: TotalFieldProps) => {
  const { getValue } = useFieldHelper<StructureItem[]>({ source });
  const structures = getValue();

  const getValues = (type: string, fieldName: string) => {
    return structures
      .filter((item: any) => {
        return item?.finance?.status !== BUDGET_STRUCTURE_STATUS.CLOSED;
      })
      .map((item: any) => item?.[type]?.[fieldName])
      .filter(value => value !== null && value !== undefined);
  };

  const calculateValue = () => {
    const budgetValues = getValues('budget', field);
    const financeValues = getValues('finance', field);
    return calculateResult(budgetValues, financeValues, showContent);
  };

  return <TextField {...props} value={calculateValue()} />;
};

export default TotalField;
